import { StyledTable } from './styles'

const DataList = ({ data, handleShowImage, isShowInputSearchUser }) => {
  return (
    <div>
      {data?.length > 0 ? (
        <StyledTable responsive striped bordered className="verticle-middle">
          <thead>
            <tr>
              <th style={{ width: '30%' }}>เลข</th>
              <th>จำนวนชุด</th>
              {isShowInputSearchUser && <th>รูปภาพลอตเตอรี่</th>}
            </tr>
          </thead>
          <tbody>
            {data?.map((item) => {
              return (
                <tr key={item.id}>
                  <td>{item.number}</td>
                  <td>{item.count}</td>
                  {isShowInputSearchUser && (
                    <td className="cursor-pointer" onClick={() => handleShowImage(item.id)}>
                      <span className="text-blue" style={{ textDecorationLine: 'underline' }}>
                        ดูรูปภาพลอตเตอรี่
                      </span>
                    </td>
                  )}
                </tr>
              )
            })}
          </tbody>
        </StyledTable>
      ) : (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
          <h4>ไม่พบข้อมูล</h4>
        </div>
      )}
    </div>
  )
}

export default DataList
